export default __webpack_public_path__ + "static/media/renuma-plus-05-1.c8d38cc8.png";